module.exports = __webpack_public_path__ + "img/MES2Indice3_cutout.3510f0db.png";